import React from 'react'
import PurchaseSummary from './PurchaseSummary'

export default function PendingFishPurSummary() {
    return (
        <PurchaseSummary xState={'RECEIVED'} />
    )
}
